import React from 'react';
import { FieldErrors, UseFormHandleSubmit, UseFormRegister, UseFormWatch } from 'react-hook-form';
import { UseMutateFunction } from '@tanstack/react-query';
import cn from 'classnames';

import RadioButton from '@components/common/Form/RadioButton';

import {
	IDefaultValuesAttribute,
	TRadioDefaultValueBool,
	TStatusOptionBool,
} from '@interfaces/components/form';

import AttributeCard from './AttributeCard';

import styles from './AttributeCard.module.scss';

interface IAttributeCardBoolStatusHOCProps {
	changeEditMode: React.Dispatch<React.SetStateAction<boolean>>;
	changeStatus: (statusName: string, value: TRadioDefaultValueBool) => void;
	detailsName: string;
	editHandler: UseMutateFunction<any>;
	errors: FieldErrors;
	handleSubmit: UseFormHandleSubmit<IDefaultValuesAttribute>;
	id?: string;
	isEditAccess: boolean;
	isEditMode: boolean;
	options: Array<TStatusOptionBool>;
	register: UseFormRegister<IDefaultValuesAttribute>;
	statusName: string;
	title: string;
	watch: UseFormWatch<IDefaultValuesAttribute>;
	fileFieldName: string;
	changeFiles: (fileFieldName: string, filesIds: Array<string>) => void;
}

const AttributeCardBoolStatusHOC = ({
	changeEditMode,
	changeStatus,
	detailsName,
	editHandler,
	errors,
	handleSubmit,
	id,
	isEditAccess,
	isEditMode,
	options,
	register,
	statusName,
	title,
	watch,
	fileFieldName,
	changeFiles,
}: IAttributeCardBoolStatusHOCProps) => {
	const radioValue = watch(statusName as any);

	const checkIcon = !isEditMode
		&& options.find((option) => option.value === radioValue)?.label.toLocaleLowerCase();

	return (
		<AttributeCard
			changeEditMode={changeEditMode}
			changeFiles={changeFiles}
			detailsName={detailsName}
			editHandler={editHandler}
			errors={errors}
			fileFieldName={fileFieldName}
			handleSubmit={handleSubmit}
			icon={checkIcon}
			id={id}
			isEditAccess={isEditAccess}
			isEditMode={isEditMode}
			radioValue={radioValue}
			register={register}
			statusName={statusName}
			title={title}
			watch={watch}
		>
			<div className={cn(styles.radioButtons, styles.row)}>
				{options.map(option => {
					const onChangeStatus = () => changeStatus(statusName, option.value);

					return (
						<RadioButton
							key={title + option.value}
							checked={option.value === radioValue}
							color={option.color}
							id={option.value + title + option.color}
							label={option.label}
							name={statusName}
							onChange={onChangeStatus}
							withUseForms
						/>
					);
				})
				}
			</div>
		</AttributeCard>
	);
};

export default AttributeCardBoolStatusHOC;
